exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#progress-spinner-wrap .trans-bg[data-v-23faf3c6] {\n  display: block;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(48, 48, 48, 0.7);\n  position: fixed;\n  left: 0;\n  top: 0;\n}\n#progress-spinner-wrap .md-progress-spinner[data-v-23faf3c6] {\n  z-index: 1111;\n  top: 35%;\n  left: 50%;\n  right: 50%;\n  position: fixed;\n}\n", ""]);

// exports
